export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro?: string
  bulletsIntro?: string
  bullets?: string[]
  secondaryBulletsIntro?: string
  secondaryBullets?: string[]
  systemLabel?: string
  system?: string
  result?: string
  closing?: string[]
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: 'Hydroponics Quick-Start Blueprint',
    subtitle: 'Build Your First System Without Guesswork',
    intro:
      'A visual startup roadmap that takes you from an empty growing space to a functioning hydroponic system.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Location selection',
      'System selection',
      'Equipment checklist',
      'Reservoir setup',
      'Pump setup',
      'Aeration',
      'Tubing',
      'Net pots',
      'Grow lights',
      'Nutrient preparation',
      'pH check',
      'EC check',
      'Flow test',
      'Leak test',
      'Seedling placement',
      'First-day inspection',
    ],
    systemLabel: 'Core sequence:',
    system: 'EMPTY SPACE → BUILD → FILL → CHECK → PLANT → GROW',
  },
  {
    id: '2',
    title: 'Maintenance Calendar & System Control Checklist',
    subtitle: 'Know What to Check Before Small Problems Become Big Problems',
    intro: 'A practical control system for your hydroponic garden.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Daily checks',
      'Weekly checks',
      'Reservoir checks',
      'pH tracking',
      'EC tracking',
      'Water-level tracking',
      'Root observations',
      'Plant observations',
      'Pump inspections',
      'Lighting checks',
      'Cleaning routines',
      'Equipment checks',
      'System reset planning',
      'Printable grow logs',
    ],
    result: 'You always know what needs attention next.',
  },
  {
    id: '3',
    title: 'Hydroponic Deficiency & Symptom Visual Atlas',
    subtitle: 'See the Warning Sign. Know What to Check First.',
    intro: 'A highly visual reference for common plant and system warning signs.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Yellow lower leaves',
      'Pale new growth',
      'Burnt tips',
      'Brown edges',
      'Curling',
      'Spots',
      'Weak stems',
      'Stretching',
      'Stunted growth',
      'Wilting',
      'Dark roots',
      'Poor root development',
      'Algae',
      'Uneven growth',
    ],
    systemLabel: 'Core system:',
    system: 'WHAT YOU SEE → WHAT TO CHECK → POSSIBLE CAUSES → NEXT ACTION',
    closing: ['SYMPTOM ≠ DIAGNOSIS', 'Check the system before guessing.'],
  },
  {
    id: '4',
    title: 'Crop Planning & Harvest System',
    subtitle: 'Turn Random Growing Into a Repeatable Harvest Plan',
    bulletsIntro: 'Plan:',
    bullets: [
      'What to grow',
      'Where to grow it',
      'When to start',
      'When to transplant',
      'When to harvest',
      'What to plant next',
    ],
    secondaryBulletsIntro: 'Includes:',
    secondaryBullets: [
      'Crop planning',
      'System compatibility',
      'Spacing',
      'Plant quantity',
      'Start dates',
      'Transplant dates',
      'Harvest windows',
      'Succession planting',
      'Continuous harvest',
      'Replacement planting',
      'Small-space planning',
      'Printable crop planner',
    ],
    result:
      'Your hydroponic garden becomes a planned food-growing system instead of a collection of random plants.',
  },
  {
    id: '5',
    title: 'Emergency Troubleshooting Flowcharts',
    subtitle: 'Know What to Do When Something Suddenly Goes Wrong',
    bulletsIntro: 'Quick decision trees for:',
    bullets: [
      'pH too high',
      'pH too low',
      'EC too high',
      'EC too low',
      'Plants wilting',
      'Pump failure',
      'Power interruption',
      'Clogged tubing',
      'Reservoir leak',
      'Algae',
      'Abnormal roots',
      'Sudden yellowing',
      'Nutrient mistakes',
      'Excessive heat',
      'Weak growth',
      'Grow-light failure',
    ],
    systemLabel: 'Core system:',
    system: 'PROBLEM → CHECK → VERIFY → ADJUST → MONITOR',
  },
]
